//

// import { simplApi } from '../../helpers/simplApi';

// const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_COMPACTMODE = 'TOGGLE_COMPACTMODE';
export const RUN_JOYRIDE = 'RUN_JOYRIDE';
export const STOP_JOYRIDE = 'STOP_JOYRIDE';
export const TOGGLE_JOYRIDE = 'TOGGLE_JOYRIDE';

// ------------------------------------
// Actions
// ------------------------------------

export function toggleSideBar() {
  return {
    type: TOGGLE_SIDEBAR,
  };
}

export function toggleCompactMode() {
  return {
    type: TOGGLE_COMPACTMODE,
  };
}

export function runJoyride() {
  return {
    type: RUN_JOYRIDE,
  };
}

export function stopJoyride() {
  return {
    type: STOP_JOYRIDE,
  };
}

export function toggleJoyride() {
  return {
    type: TOGGLE_JOYRIDE,
  };
}

export const actions = {
  toggleSideBar,
  toggleCompactMode,
  runJoyride,
  stopJoyride,
  toggleJoyride,
};

const OPTIONS_ACTION_HANDLERS = {
  [TOGGLE_SIDEBAR]: state => {
    localStorage.setItem('sideBarOpen', !state.sidebarOpen);
    return {
      ...state,
      sidebarOpen: !state.sidebarOpen,
    };
  },
  [TOGGLE_COMPACTMODE]: state => {
    localStorage.setItem('compactMode', !state.compactMode);
    return {
      ...state,
      compactMode: !state.compactMode,
    };
  },
  [RUN_JOYRIDE]: state => ({
    ...state,
    runJoyride: true,
  }),
  [STOP_JOYRIDE]: state => ({
    ...state,
    runJoyride: false,
  }),
  [TOGGLE_JOYRIDE]: state => ({
    ...state,
    runJoyride: !state.runJoyride,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

let sidebarOpen = localStorage.getItem('sideBarOpen');
sidebarOpen = sidebarOpen === 'true';

let compactMode = localStorage.getItem('compactMode');
compactMode = compactMode === 'true';

export const initialState = {
  sidebarOpen,
  compactMode,
  runJoyride: false,
};

export default function optionsReducer(state = initialState, action) {
  const handler = OPTIONS_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/options.js